// These polyfills are needed for the draft-js editor
import 'core-js/fn/array/from';
import 'core-js/fn/string/starts-with';
import 'core-js/fn/string/ends-with';

import * as React from 'react';
import '@notes/sticky-notes-layout/dist/LayoutSDK.global.css';
import { LayoutComponent } from '@notes/sticky-notes-layout';
import getNotesSDK from '../utils/getNotesSDK';

export interface NotesPaneProps {
    header: JSX.Element;
}

// tslint:disable:prefer-functional-components
export default class NotesPane extends React.Component<NotesPaneProps, any> {
    render() {
        return <LayoutComponent sdk={getNotesSDK()} customHeaderContent={this.props.header} />;
    }
}
